export enum REPORT_STATUS {
	COMPLETE = 'complete',
	START = 'start',
}

export enum REPORT_PROVIDER {
	KVBO = 'KVBO',
	HCS = 'HCS',
	KVD = 'KVD',
	KTS34 = 'KTS34',
	KTS56 = 'KTS56',
	HEZ = 'HEZ',
}

export enum REPORT_TYPE {
	DAILY_HEADERS = 'dailyHeaders',
	MONTHLY_HEADERS = 'monthHeaders',
	PAYMENT_REGISTER = 'paymentRegister',
}
